export const environment = {
  production: true,
  version: '3.0.95'
};
